import { render, staticRenderFns } from "./MemoryForm.vue?vue&type=template&id=4d0417ce&scoped=true&lang=pug&"
import script from "./MemoryForm.vue?vue&type=script&lang=js&"
export * from "./MemoryForm.vue?vue&type=script&lang=js&"
import style0 from "./MemoryForm.vue?vue&type=style&index=0&id=4d0417ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0417ce",
  null
  
)

export default component.exports